import Select, { createFilter, components } from "react-select";
import "../../styles/select.css";
import { useRef } from "react";

const CustomOption = ({ children, ...props }) => {
  // eslint-disable-next-line no-unused-vars
  const { onMouseMove, onMouseOver, ...rest } = props.innerProps;
  const newProps = { ...props, innerProps: rest };
  return <components.Option {...newProps}>{children}</components.Option>;
};

const selectAllOption = {
  value: "<SELECT_ALL>",
  label: "All Items",
};

const SpotMultiSelect = props => {
  const valueRef = useRef(props.value);
  valueRef.current = props.value;

  const isSelectAllSelected = () =>
    props.options.length
      ? valueRef.current.length === props.options.length
      : false;

  const isOptionSelected = option =>
    valueRef.current.some(({ value }) => value === option.value) ||
    isSelectAllSelected();

  const getOptions = () =>
    isSelectAllSelected() ? [] : [selectAllOption, ...props.options];

  const getValue = () =>
    isSelectAllSelected() ? [selectAllOption] : props.value;

  const onChange = (newValue, actionMeta) => {
    const { action, option, removedValue } = actionMeta;

    if (action === "select-option" && option.value === selectAllOption.value) {
      props.onChange(props.options, actionMeta);
    } else if (
      (action === "deselect-option" &&
        option.value === selectAllOption.value) ||
      (action === "remove-value" &&
        removedValue.value === selectAllOption.value)
    ) {
      props.onChange([], actionMeta);
    } else if (
      actionMeta.action === "deselect-option" &&
      isSelectAllSelected()
    ) {
      props.onChange(
        props.options.filter(({ value }) => value !== option.value),
        actionMeta
      );
    } else {
      props.onChange(newValue || [], actionMeta);
    }
  };

  return (
    <div className="spot-select">
      <Select
        {...props}
        unstyled
        className="spot-select-container"
        classNamePrefix="spot-select"
        filterOption={createFilter({ ignoreAccents: false })}
        components={{ Option: CustomOption }}
        captureMenuScroll={false}
        isOptionSelected={isOptionSelected}
        options={getOptions()}
        value={getValue()}
        onChange={onChange}
        hideSelectedOptions={false}
        closeMenuOnSelect={false}
        isMulti
      />
    </div>
  );
};

export default SpotMultiSelect;
